import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { Speech } from '@/speech'

import languages from '@/assets/languages.json'

export default {
  namespaced: true,
  state: {
    speech: null,
    languages: languages.languages,
  },
  mutations: {
    init(state){
      state.speech = new Speech()
    },
  },
  actions: {
    init({commit}){
      commit('init')
    },
    checkSupport ({state}) {
      state.speech.checkSupport();
    },
    start ({state}) {
      state.speech.start();
    },
    stop ({state}) {
      state.speech.stop();
    },
    restart ({state}) {
      state.speech.restart();
    },
    setLanguage ({state},payload) {
      state.speech.setLanguage(payload.language);
    },
  },
  getters: {
    isRunning: (state) => () => {
      return state.speech.isRunning()
    },
  },
}
